import { AutogenModelPnnTranscoreUsers, AutogenRowPnnTranscoreUsers } from "./autogen/AutogenModelPnnTranscoreUsers";

export class ModelPnnTranscoreUsers extends AutogenModelPnnTranscoreUsers<RowPnnTranscoreUsers> {
	constructor() {
		super(RowPnnTranscoreUsers);
	}
}

export class RowPnnTranscoreUsers extends AutogenRowPnnTranscoreUsers {
}